import React from 'react';

import CopyrightText from './copyrightText';

import * as ST from './styled';

interface ICopyright {
    copyrightLink: string,
    cobrandLegalEntity?: string,
    cobrandCopyrightLink?: string,
}

export const Copyright = ({ copyrightLink, cobrandLegalEntity, cobrandCopyrightLink }: ICopyright): JSX.Element => {
    return (
        <ST.Copyright>
            <ST.CopyrighLeft>
                <CopyrightText company={'АО «ЭР-Телеком Холдинг»'} link={copyrightLink}/>
                {cobrandCopyrightLink && cobrandLegalEntity &&
                    <CopyrightText company={cobrandLegalEntity} link={cobrandCopyrightLink}/>}
            </ST.CopyrighLeft>
            <ST.CopyrightCompany>&copy; АО &laquo;ЭР-Телеком
                Холдинг&raquo; 2011-{new Date().getFullYear()}</ST.CopyrightCompany>
        </ST.Copyright>
    );
};
